// host · shell · tabler icon
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TABLER_ICON_PATHS from './tablerIcons';
import styles from './TablerIcon.module.postcss';

/*
 * Inline-SVG replacement for the Tabler webfont the mockups load from a CDN
 * (the app must not carry that font). Usage mirrors the mockup class names:
 *
 *   <i class="ti ti-calendar">            →  <TablerIcon name="calendar" />
 *   <i class="ti ti-star-filled">         →  <TablerIcon name="star-filled" />
 *
 * `size` maps to the mockups' icon font-size (default 18, the sidebar size).
 * Color comes from CSS `currentColor`, exactly like the webfont did.
 */
function TablerIcon({ name, size = 18, className, ...rest }) {
  const paths = TABLER_ICON_PATHS[name];
  if (!paths) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`TablerIcon: unknown icon "${name}"`); // eslint-disable-line no-console
    }
    return null;
  }

  const filled = name.endsWith('-filled');

  return (
    <svg
      className={cn(styles.Icon, className)}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={filled ? undefined : 2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
      {...rest}
    >
      {paths.split('|').map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
}

TablerIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default TablerIcon;
